import { validateComponent } from '../../../utils'

const inputTextValidator = (component) => {
  const {
    options: { isRequired, requiredErrorMessage, submission },
  } = component

  if (isRequired) {
    const validators = [
      {
        validationFunction: () =>
          submission && (submission.value || '').trim().length > 0,
        validationKey: 'value',
        validationMessage: requiredErrorMessage,
      },
    ]
    validateComponent(component, validators)
  } else {
    component.isValid = true
  }

  return component.isValid
}

export default inputTextValidator
